import { Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ReactComponent as StarIcon } from "../../../assets/MiniProfileStarIcon.svg";

const useStyles = makeStyles((theme) => ({
  profileCircle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "54px",
    height: "54px",
    backgroundColor: "#E2F7FF",
    borderRadius: "50%",
    margin: "0 auto",
    position: "relative",
  },
  initials: {
    fontSize: "1.35em",
    fontWeight: 600,
    color: theme.palette.text.secondary,
  },
}));

interface ProfileAvatarProps {
  initials: string;
  hideStar?: boolean;
}

export const ProfileAvatar = (props: ProfileAvatarProps) => {
  const classes = useStyles();
  const { hideStar, initials } = props;
  return (
    <Box>
      <Box className={classes.profileCircle}>
        <Typography component="span" variant="h1" className={classes.initials}>
          {initials}
        </Typography>
        {!hideStar && (
          <StarIcon style={{ width: 84, height: 52.2, position: "absolute" }} />
        )}
      </Box>
    </Box>
  );
};
